import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import "./module.approve-user.css"; // We'll create this CSS file

const ApproveUser = () => {
    const [status, setStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(true);
    const [admins, setAdmins] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState("");
    const [userRole, setUserRole] = useState("");
    const [showActionButtons, setShowActionButtons] = useState(true);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("success");

    const location = useLocation();

    const getQueryParams = () => {
        const urlParams = new URLSearchParams(location.search);
        return { userId: urlParams.get("userId"), action: urlParams.get("action") };
    };

    const { userId, action } = getQueryParams();

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get(`http://localhost:4500/user-details`, {
                    params: { userId },
                });
                
                setUserRole(response.data.role);

                if (response.data.role === "client") {
                    const adminResponse = await axios.get(`http://localhost:4500/admin-list`);
                    setAdmins(adminResponse.data.admins);
                }
            } catch (error) {
                console.error("Error fetching user details:", error);
                showPopup("Failed to fetch user data.", "error");
            } finally {
                setDataLoading(false);
            }
        };

        fetchUserData();
    }, [userId]);

    const showPopup = (message, type = "success") => {
        setPopupMessage(message);
        setPopupType(type);
        setShowSuccessPopup(true);
        setTimeout(() => {
            setShowSuccessPopup(false);
        }, 4000);
    };

    const handleAssignAdmin = async () => {
        if (!selectedAdmin) {
            showPopup("Please select an admin.", "error");
            return;
        }

        setIsLoading(true);
        try {
            await axios.post(`http://localhost:4500/assign-admin`, {
                userId,
                adminId: selectedAdmin,
            });
            handleUserAction("approve");
            showPopup("Admin assigned successfully! Now you can approve the client.", "success");
        } catch (error) {
            console.error("Error assigning admin:", error);
            showPopup("Failed to assign admin.", "error");
        }
        setIsLoading(false);
    };

    const handleUserAction = async (actionType) => {
        if (!userId || !actionType) {
            showPopup("Invalid parameters. Please check the link.", "error");
            return;
        }
        if (userRole === "client" && !selectedAdmin && actionType === 'approve') {
            showPopup("Please assign an admin first.", "error");
            return;
        }

        setIsLoading(true);
        setShowActionButtons(false);
        
        try {
            const response = await axios.get(`http://localhost:4500/approve-user`, {
                params: { userId, action: actionType },
            });

            if (response.status === 200) {
                showPopup(response.data.message, "success");
                setStatus(response.data.message);
            } else {
                showPopup("An error occurred while processing the request.", "error");
            }
        } catch (error) {
            console.error("Server Error:", error);
            showPopup("Server error. Please try again later.", "error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="approve-user-section">
            <div className="main-width">
                <div className="approve-container">
                    <div className="approve-header">
                        <div className="logo-placeholder">
                            <div className="logo-circle dark-red"></div>
                            <div className="logo-circle dark-blue"></div>
                            <span className="logo-text">SuryaGroup</span>
                        </div>
                        <h1 className="approve-title">
                            User <span className="action-highlight">{action}</span>
                        </h1>
                        <p className="approve-subtitle">
                            Confirm the user account action below
                        </p>
                    </div>

                    {dataLoading ? (
                        <div className="loading-container">
                            <div className="spinner">
                                <div className="spinner-circle"></div>
                                <div className="spinner-circle"></div>
                                <div className="spinner-circle"></div>
                            </div>
                            <p className="loading-text">Loading user details...</p>
                        </div>
                    ) : (
                        <>
                            <div className="action-card">
                                {!status && !isLoading && showActionButtons && (
                                    <>
                                        {userRole === "client" && admins.length > 0 && action === 'approve' ? (
                                            <div className="admin-assignment">
                                                <div className="input-group">
                                                    <label className="input-label">
                                                        <i className="fas fa-user-shield"></i>
                                                        Select Admin for Client
                                                    </label>
                                                    <div className="select-wrapper">
                                                        <select 
                                                            className="admin-select"
                                                            onChange={(e) => setSelectedAdmin(e.target.value)} 
                                                            value={selectedAdmin}
                                                        >
                                                            <option value="">-- Choose an admin --</option>
                                                            {admins.map((admin) => (
                                                                <option key={admin._id} value={admin._id}>
                                                                    {admin.firstName} {admin.lastName} ({admin.email})
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <i className="fas fa-chevron-down select-arrow"></i>
                                                    </div>
                                                </div>
                                                
                                                <button 
                                                    className="assign-button"
                                                    onClick={handleAssignAdmin}
                                                    disabled={!selectedAdmin}
                                                >
                                                    <i className="fas fa-link"></i>
                                                    Assign Admin & Continue
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="confirmation-section">
                                                <div className="confirmation-icon">
                                                    <i className="fas fa-question-circle"></i>
                                                </div>
                                                <p className="confirmation-text">
                                                    Are you sure you want to <strong className={`action-${action}`}>{action}</strong> this user?
                                                </p>
                                                
                                                <div className="action-buttons">
                                                    <button 
                                                        className="action-btn approve-btn"
                                                        onClick={() => handleUserAction(action)}
                                                    >
                                                        <i className="fas fa-check-circle"></i>
                                                        Yes, {action}
                                                    </button>
                                                    <button 
                                                        className="action-btn reject-btn"
                                                        onClick={() => {
                                                            showPopup("No changes made.", "info");
                                                            setStatus("No changes made.");
                                                            setShowActionButtons(false);
                                                        }}
                                                    >
                                                        <i className="fas fa-times-circle"></i>
                                                        No, Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}

                                {isLoading && (
                                    <div className="processing-container">
                                        <div className="processing-spinner"></div>
                                        <p className="processing-text">Processing your request...</p>
                                    </div>
                                )}

                                {status && (
                                    <div className="result-container">
                                        <div className={`result-icon ${popupType}`}>
                                            <i className={`fas fa-${popupType === 'success' ? 'check-circle' : popupType === 'error' ? 'exclamation-circle' : 'info-circle'}`}></i>
                                        </div>
                                        <p className="result-text">{status}</p>
                                        <Link to="/" className="home-link">
                                            <i className="fas fa-home"></i>
                                            Go to Homepage
                                        </Link>
                                    </div>
                                )}
                            </div>

                            <div className="info-box">
                                <i className="fas fa-info-circle"></i>
                                <p>This action will update the user's account status. Once completed, you'll be redirected to the homepage.</p>
                            </div>
                        </>
                    )}

                    {/* Animated Popup */}
                    {showSuccessPopup && (
                        <div className={`popup-container ${popupType} show`}>
                            <div className="popup-content">
                                <div className="popup-icon">
                                    <i className={`fas fa-${popupType === 'success' ? 'check-circle' : popupType === 'error' ? 'exclamation-circle' : 'info-circle'}`}></i>
                                </div>
                                <div className="popup-text">
                                    <h4>{popupType === 'success' ? 'Success!' : popupType === 'error' ? 'Error!' : 'Info'}</h4>
                                    <p>{popupMessage}</p>
                                </div>
                                <button className="popup-close" onClick={() => setShowSuccessPopup(false)}>
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ApproveUser;